<script>
export default {
  name: 'develop',
  data() {
    return {
      developTitle: '海邻大事记',
      developDescription: '当创新成为时代的延展<br>我们在日新月异的进程中相互印证',
      developSize: { width: 3868 * 0.3, height: 5621 * 0.3 },
      developAbout: [
        {
          Id: 1,
          year: '2014',
          events: [
            { month: '4月', details: ['内蒙古中润成立'] }
          ],
          position: { x: 730, y: 190 },
          textAlign: 'right',
          dotPosition: { x: 800, y: 225 },
        },
        {
          Id: 2,
          year: '2017',
          events: [
            { month: '12月', details: ['通辽海邻成立'] }
          ],
          position: { x: 300, y: 300 },
          textAlign: 'right',
          dotPosition: { x: 500, y: 440 },
        },
        {
          Id: 3,
          year: '2018',
          events: [
            { month: '12月', details: ['内蒙古海邻成立'] }
          ],
          position: { x: 900, y: 400 },
          textAlign: 'left',
          dotPosition: { x: 800, y: 540 },
        },
        {
          Id: 4,
          year: '2019',
          events: [
            { month: '12月', details: ['绥化海邻成立'] }
          ],
          position: { x: 520, y: 550 },
          textAlign: 'right',
          dotPosition: { x: 666, y: 700 },
        },
        {
          Id: 5,
          year: '2020',
          events: [
            { month: '12月', details: ['中润获得“高新技术企业”认定'] }
          ],
          position: { x: 800, y: 710 },
          textAlign: 'left',
          dotPosition: { x: 680, y: 810 },
        },
        {
          Id: 6,
          year: '2021',
          events: [
            { month: '7月', details: ['通辽梅花入股通辽海邻'] },
            { month: '12月', details: ['通辽海邻获得“高新技术企业”认定'] }
          ],
          position: { x: 550, y: 830 },
          textAlign: 'left',
          dotPosition: { x: 490, y: 885 },
        },
        {
          Id: 7,
          year: '2022',
          events: [
            { month: '1月', details: ['大庆裕丰项目签约'] }
          ],
          position: { x: 160, y: 950 },
          textAlign: 'right',
          dotPosition: { x: 343, y: 1080 },
        },
        {
          Id: 8,
          year: '2023',
          events: [
            { month: '5月', details: ['龙江海邻项目签约'] },
            { month: '8月', details: ['中润获得“专精特新”中小企业认定'] },
            { month: '12月', details: ['入自治区上市后备库内股交展示板挂牌'] }
          ],
          position: { x: 250, y: 1130 },
          textAlign: 'right',
          dotPosition: { x: 520, y: 1184 },
        },
        {
          Id: 9,
          year: '2024',
          events: [
            { month: '3月', details: ['呼伦海邻成立、与中泰证券签署上市服务协议'] },
            { month: '4月', details: ['内股交天骏板挂牌'] },
            { month: '6月', details: ['通辽海邻获得“专精特新”中小企业认定'] },
            { month: '9月', details: ['大庆海邻成立'] }
          ],
          position: { x: 700, y: 1350 },
          textAlign: 'right',
          dotPosition: { x: 795, y: 1400 },
        },
      ]
    };
  },
};
</script>

<template>
  <div class="develop">
    <div class="developTitle">
      <h2>{{ developTitle }}</h2>
      <p v-html="developDescription"></p>
    </div>

    <img src="@/assets/history/history.png" style="width: 100%">
<!--    <div class="box-develop">-->
<!--      <div class="develop-background" :style="{ width: `${developSize.width}px`, height: `${developSize.height}px` }">-->
<!--        <div-->
<!--            class="develop-dot"-->
<!--            v-for="item in developAbout"-->
<!--            :key="item.Id"-->
<!--            :style="{-->
<!--          top: item.position.y + 'px',-->
<!--          left: item.position.x + 'px',-->
<!--          'text-align': item.textAlign,-->
<!--        }"-->
<!--        >-->
<!--          <p class="year">{{ item.year }}</p>-->
<!--          <div v-for="(eventGroup, eIndex) in item.events" :key="`eventGroup-${item.Id}-${eIndex}`">-->
<!--            <p class="month">{{ eventGroup.month }}</p>-->
<!--            <div v-for="(event, dIndex) in eventGroup.details" :key="`event-${item.Id}-${eIndex}-${dIndex}`">-->
<!--              <p class="event">{{ event }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div-->
<!--          class="developDot"-->
<!--          v-for="item in developAbout"-->
<!--          :key="`dot-${item.Id}`"-->
<!--          :style="{ top: item.dotPosition.y + 'px', left: item.dotPosition.x + 'px', width: 88 * 0.3 + 'px', height: 204 * 0.3 + 'px'  }"-->
<!--      >-->
<!--        <img src="@/assets/history/develop-dot.png" alt="Dot" />-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<style scoped>
.develop {
  position: relative;
  margin: 2vw;
  font-family: 'SimSun', 'Songti SC', serif; /* 尝试使用宋体或类似字体 */
  height: auto;
}

.developTitle {
  text-align: center;
  margin-bottom: 2vw;
}

.developTitle h2 {
  font-size: 2.5vw;
  font-weight: bold;
  line-height: 2.8;
  color: #00A0FA;
}

.developTitle p {
  font-size: 1.5vw;
  line-height: 1.8;
  color: #666;
}

.develop-background {
  margin-top: 20px;
  background: url("@/assets/history/develop-history-line.png") no-repeat center;
  background-size: contain;
  position: relative;
  top:-20px;
  overflow: hidden;
}

.develop-dot {
  position: absolute;
  padding: 10px;
  border-radius: 5px;
  max-width: 300px;

}

.title {
  font-family: 'SimSun', 'Songti SC', serif; /* 尝试使用宋体或类似字体 */
  font-size: 2vw; /* 根据需要调整字体大小 */
  color: #007BFF; /* 设置字体颜色 */
  text-align: center; /* 居中对齐 */
}
.develop-dot .year {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #007BFF;
  line-height: 20px;

}

.develop-dot .month {
  font-size: 16px;
  color: grey;
  margin-bottom: 2px;
  line-height: 0;

}

.develop-dot .event {
  font-size: 12px;
  color: black;
  margin-bottom: 5px;
  white-space: nowrap;
}

.developDot {
  position: absolute;
  z-index: 10;
}

.developDot img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.box-develop{
  width: 100vw;
  align-content: center;
  justify-content: center;
  text-align: center;
}
</style>
